import React from "react";

interface StatisticsCardProps {
    label: string;
    value: string | number;
    subtitle?: string | number;
    percentage?: number;
    className?: string;
    valueClassName?: string;
    subtitleClassName?: string;
}

export const StatisticsCard: React.FC<StatisticsCardProps> = ({
    label,
    value,
    subtitle,
    percentage,
    className = "",
    valueClassName = "",
    subtitleClassName = "",
}) => {
    return (
        <div
            className={`p-3 bg-slate-50 rounded-lg border border-slate-200 ${className}`}
        >
            <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-slate-600">{label}</span>
                {percentage !== undefined && (
                    <span className="text-xs font-medium text-slate-500">
                        {percentage}%
                    </span>
                )}
            </div>
            <div className="flex items-baseline gap-1">
                <span
                    className={`text-lg font-bold text-slate-900 ${valueClassName}`}
                >
                    {value}
                </span>
                {subtitle !== undefined && (
                    <span
                        className={`text-sm text-slate-500 ${subtitleClassName}`}
                    >
                        / {subtitle}
                    </span>
                )}
            </div>
        </div>
    );
};
